import Vue from 'vue';
import Vuesax from 'vuesax'
import Notifications from 'vue-notification'
import App from './App.vue';
import 'vuesax/dist/vuesax.css' //Vuesax styles
//import 'material-icons/iconfont/material-icons.css';
import 'material-icons/iconfont/material-icons.css';
import 'nprogress/nprogress.css';
import VueSocialSharing from 'vue-social-sharing'
import VueYouTubeEmbed from 'vue-youtube-embed'


import store from './store/store';
import router from './router';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import VueGtag from "vue-gtag";
import VueGtm from '@gtm-support/vue2-gtm';

import i18n from './i18n'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.use(VueSocialSharing);

Vue.use(VueYouTubeEmbed);

Vue.use(Notifications);

Vue.config.productionTip = true;

Vue.use(Vuesax)

Vue.use(VueGtm, {
    id: 'GTM-TBWW34B',
    defer: false,
    compatibility: false,
    enabled: true,
    loadScript: true,
    vueRouter: router
  });

Vue.prototype.$t = (key, options) => i18n.t(key, options);

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
import "./filters"
